export const arrayMove = <T>(arr: T[], fromIndex: number, toIndex: number): T[] => {
    const arrayCopy = [...arr];
    const element = arrayCopy.splice(fromIndex, 1)[0];

    arrayCopy.splice(toIndex, 0, element);

    return arrayCopy;
};